export default __webpack_public_path__ + "static/media/the_venue_2.780e5adf.png";